import { Button, Modal, useSnackbar } from '@tecsinapse/cortex-react'
import { Trans } from '@lingui/react/macro'
import React from 'react'
import { Funcionalidade, Produto } from '@/core/types/graphql'
import { UsuarioPermissaoItem } from '../columns-permissao'
import { useFormContext, useWatch } from 'react-hook-form'
import { t } from '@lingui/core/macro'

const clonarTiposAcessoEFuncionalidades = ({
  values,
  selectedRow,
  produtos,
  setValue
}: any) => {
  const novasPemissoes = JSON.parse(JSON.stringify(values.produtos))

  produtos.forEach((produto: Produto) => {
    const idProduto = produto.id

    const permisProduto = novasPemissoes[idProduto]

    permisProduto.idsTiposAcesso = []
    permisProduto.funcionalidades = []

    const tipoAcesProduto = selectedRow.tiposAcessoByProduto[idProduto]

    if (tipoAcesProduto) {
      permisProduto.idsTiposAcesso = [...tipoAcesProduto.tiposAcesso].map(
        ({ id, nome }) => ({
          label: nome,
          value: id
        })
      )
      permisProduto.funcionalidades = (
        selectedRow.funcionalidades as Funcionalidade[]
      )
        .filter(f => f.produto.id === idProduto)
        .map(({ id }) => id)
    }
  })

  setValue('produtos', novasPemissoes)
}

export type CustomProps = {
  open: boolean
  produtos: Produto[]
}
export interface ModalConfirmacaoProps {
  selectedRow?: UsuarioPermissaoItem
  openModalConfirmacao: boolean
  setOpenModalConfirmacao: (openModalConfirmacao: boolean) => void
  setOpenTable: React.Dispatch<React.SetStateAction<boolean>>
  customProps: CustomProps
}

export const ModalConfirmacao = (props: ModalConfirmacaoProps) => {
  const {
    selectedRow,
    openModalConfirmacao,
    setOpenModalConfirmacao,
    setOpenTable,
    customProps
  } = props
  const { snackbar } = useSnackbar()
  const values = useWatch()
  const { setValue } = useFormContext()

  const onClose = () => {
    setOpenModalConfirmacao(false)
    setOpenTable(true)
  }

  const { nome } = values
  const { produtos } = customProps

  return (
    <Modal
      open={openModalConfirmacao}
      onClose={onClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <div className='flex flex-col space-y-mega'>
        <p className={'font-bold text-center'}>
          <Trans>
            Deseja clonar as permissões do usuário {selectedRow?.nome}?
          </Trans>
        </p>
        <p className={'mb-giga'}>
          <Trans>
            As permissões do usuário{' '}
            <span className={'font-bold'}>{nome} </span>
            serão substituídas pelas permissões do usuário{' '}
            <span className={'font-bold'}>{selectedRow?.nome}</span>.
            <p>
              Você ainda poderá editá-las após a confirmação. Deseja continuar?
            </p>
          </Trans>
        </p>
        <div
          className={'flex items-center justify-between flex-row space-x-deca '}
        >
          <Button
            variants={{ variant: 'outline', className: 'w-full' }}
            type={'button'}
            onClick={onClose}
          >
            <Trans>Cancelar</Trans>
          </Button>
          <Button
            variants={{ className: 'w-full' }}
            type={'button'}
            onClick={() => {
              clonarTiposAcessoEFuncionalidades({
                selectedRow,
                values,
                produtos,
                setValue
              })
              setOpenModalConfirmacao(false)
              snackbar.show('success', t`Permissões clonadas com sucesso!`)
            }}
          >
            <Trans>Confirmar</Trans>
          </Button>
        </div>
      </div>
    </Modal>
  )
}
